import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import lozad from 'lozad'
import { CSSPlugin } from 'gsap/CSSPlugin'
//import { portfolio } from 'routes/portfolio'
import CareersModal from '../components/popup-careers.svelte'
import TermsModal from '../components/popup-terms.svelte'
import PrivacyModal from '../components/popup-privacy.svelte'
import LoginModal from '../components/popup-login.svelte'
import {
	strategySlider,
	caseStudiesTestimonialsCarousel,
	caseStudiesTestimonialsRotator,
} from './blocks'
import BigPicture from 'bigpicture'

const { $ } = window
const $body = $(document.body)

// fade in team members on scroll
// Intersection Observer callback
const observerCallback = (entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.remove('not-visible')
			observer.unobserve(entry.target)
		}
	})
}

// Create an observer instance
const observer = new IntersectionObserver(observerCallback, {
	threshold: 0.1,
})

// Observe grid items
function observeItems() {
	const items = document.querySelectorAll('.team-item')
	items.forEach((item) => {
		item.classList.add('not-visible')
		observer.observe(item)
	})
}

export default {
	init() {
		function handleMobileProperty() {
			if (!$('.tf-prop--section')) {
				return
			}

			$('#tf-prop--active').click(function (e) {
				e.stopPropagation()
				$('.tf-prop--nav-options').toggleClass('inactive')
			})

			$(window).click(function () {
				if (!$('.tf-prop--nav-options').hasClass('.inactive')) {
					$('.tf-prop--nav-options').addClass('inactive')
				}
			})

			$('.tf-prop--nav-options button').each(function (index, button) {
				$(button).click(function () {
					$('.tf-prop--card').each(function (idx) {
						if (index == idx) {
							$(this).addClass('mobile-active')
							$(this).removeClass('mobile-inactive')
							$('#tf-prop--active span').text($(this).data('location'))
						} else {
							$(this).addClass('mobile-inactive')
							$(this).removeClass('mobile-active')
						}
					})
					$('.tf-prop--nav-options').addClass('inactive')

					$('.tf-prop--nav-options button').each(function (i) {
						$(this).removeClass('hidden')
						if (i == index) {
							$(this).addClass('hidden')
						}
					})
				})
			})
		}

		handleMobileProperty()

		function initSeniorExecsMobileSlider() {
			if (!$('.tf-senior-execs--grid')) {
				return
			}

			if (window.matchMedia('(max-width: 576px)').matches) {
				$('.tf-senior-execs--grid:not(.slick-initialized)').slick({
					arrows: true,
					dots: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					appendArrows: $('.tf-senior-execs--section .tf-m-slider--nav'),
				})
			} else {
				$('.tf-senior-execs--grid.slick-initialized').slick('unslick')
			}
		}

		initSeniorExecsMobileSlider()

		function initRegionalSlider() {
			if (!$('.regional-teams--members')) {
				return
			}

			$('.regional-teams--members').each(function () {
				if (window.matchMedia('(max-width: 576px)').matches) {
					if (!$(this).hasClass('slick-initialized')) {
						$(this).slick({
							arrows: true,
							dots: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: false,
							accessibility: false,
							appendArrows: $(this).siblings('.tf-m-slider--nav'),
							touchThreshold: 50,
							adaptiveHeight: true
						})
					}
				} else if ($(this).hasClass('slick-initialized')) {
					$(this).slick('unslick')
				}
			})
		}

		initRegionalSlider()

		$(window).on('resize', function () {
			initSeniorExecsMobileSlider()
			initRegionalSlider()
		})

		handleCareerForms()

		function handleRegionalTeams() {
			if (!$('.tf-resional-teams--section')) {
				return
			}

			$('#r-name').on('click', function (e) {
				e.stopPropagation()
				$('.tf-regional-team-names--options').toggleClass('inactive')
			})

			$(window).click(function () {
				if (!$('.tf-regional-team-names--options').hasClass('.inactive')) {
					$('.tf-regional-team-names--options').addClass('inactive')
				}
			})

			$('.tf-regional-team-names--options .tf-r-team--name').each(function (
				index
			) {
				$(this).on('click', function () {
					$('.tf-r-team--name').each(function () {
						$(this).removeClass('active')
					})
					$(this).addClass('active')
					$('#r-name span').text($(this).find('span').text())
					$('.regional-teams--team').each(function (idx) {
						if (index == idx) {
							$(this).removeClass('inactive')
							$(this).addClass('active')
						} else {
							$(this).removeClass('active')
							$(this).addClass('inactive')
						}
					})
				})
			})
		}

		function handleRegionalPageLoad() {
			const $regionBtns = $('.tf-r-team--name:not(#r-name)')
			const $regionContents = $('.regional-teams--team')

			let noValues = false

			if (!$regionBtns) {
				return
			}

			$regionBtns.each(function () {
				if (window.location.href.includes($(this).data('region'))) {
					$('#r-name span').text($(this).find('span').text())
					$(this).addClass('active')
					noValues = true

					const section = document.getElementById('regional-section')
					const navbar = document.querySelector('.navbar')
					const topOffset = section.offsetTop - navbar.offsetHeight

					window.scrollTo({ top: topOffset })
				} else {
					$(this).removeClass('active')
				}
			})

			$regionContents.each(function () {
				if (window.location.href.includes($(this).data('team-region'))) {
					$(this).addClass('active')
					$(this).removeClass('inactive')
				} else {
					$(this).removeClass('active')
					$(this).addClass('inactive')
				}
			})

			if (!noValues) {
				$regionBtns.each(function (i) {
					if (i == 0) {
						$(this).addClass('active')
					}
				})

				$regionContents.each(function (i) {
					if (i == 0) {
						$(this).addClass('active')
						$(this).removeClass('inactive')
					}
				})
			}
		}

		handleRegionalPageLoad()
		handleRegionalTeams()

		/**
		 * Handle the page modal block if it exists.
		 * 	- Show the modal if 3 weeks have passed since the last shown time
		 * @returns {void}
		 */
		function handlePageModal () {
			if (!document.querySelector('.page-modal')) {
				return
			}
		
			document.addEventListener('DOMContentLoaded', function () {
				let modal = document.getElementById('notice-modal')
		
				// Get the last shown timestamp from localStorage
				let lastShown = localStorage.getItem('modalLastShown')
				let now = new Date().getTime()
		
				// calculate 3 weeks from last shown
				let three_weeks = parseInt(lastShown, 10) + parseInt(21 * 24 * 60 * 60 * 1000, 10)
		
				// if 3 weeks have passed since the modal was closed, show the modal
				if (lastShown && three_weeks <= now) {
					if (lastShown >= (now - (21 * 24 * 60 * 60 * 1000))) {
						lastShown = false
						localStorage.setItem('modalLastShown', '')
					}
				}
		
				// Check if 24 hours (3 weeks) have passed since the last shown time
				if ( !lastShown ) {
					// Show the modal
					modal.classList.add('page-modal--show')
					// Disable background scrolling by adding no-scroll class to body
					document.body.classList.add('no-scroll')
					// Update the last shown timestamp in localStorage
					localStorage.setItem('pageModalLastShown', now) //todo
				}
		
				/**
				 * @function handleExit()
				 *
				 *  Redirect when clicking outside of the page modal element or on the close button, or if decline is clicked.
				 * 	- Only if modal is visible
				 *
				 * @param event
				 * @param clickoutside
				 */
				function handleExit(event, clickoutside = false) {
					if ($('.page-modal').is(':visible')) {
						let this_url = document
							.querySelector('.page-modal')
							.getAttribute('data-exit-url')
						if (clickoutside) {
							let this_modal = document.querySelector('.page-modal__content')
							if (!this_modal.contains(event.target)) {
								event.preventDefault()
								document.location.href = this_url
							}
						} else {
							event.preventDefault()
							document.location.href = this_url
						}
					}
				}
		
				/**
				 * Function handleAccept()
				 *
				 * Handles the clicking of the accept button.  Checks if form input is checked and if not, shows
				 * an error message.  If it is checked, it sets the local storage item and closes the modal.
				 */
				function handleAccept(e) {
					e.preventDefault()
					let form_input = $('.page-modal form input[type="checkbox"]')
					if (form_input.is(':checked')) {
						let now_time = new Date().getTime()
						localStorage.setItem('modalLastShown', now_time)
						$('.page-modal').hide()
						document.body.classList.remove('no-scroll')
					} else {
						$('.page-modal__input-error').remove()
						let paragraph = document.createElement('p')
						paragraph.innerText = '* Please confirm'
						paragraph.classList.add('page-modal__input-error')
						$('.page-modal form div').after(paragraph)
					}
				}
		
				/**
				 * Clicking outside the modal should redirect.
				 */
				$(document).on('click', function (event) {
					handleExit(event, true)
				})
		
				/**
				 * Clicking the close button should redirect.
				 */
				$('.page-modal__button-close').on('click', function (event) {
					handleExit(event)
				})
		
				/**
				 * Clicking the decline button should redirect.
				 */
				$('.page-modal .buttons__wrap a.outlined-red').on('click', function (event) {
					handleExit(event, false)
				})
		
				/**
				 * Clicking the accept button.
				 */
				$('.page-modal .buttons__wrap a:first-of-type').on('click', function (e) {
					handleAccept(e)
				})
			})
		}

		handlePageModal()

		/**
		 * Intersection observer to show background images when scrolled into viewport instead of on hover for blue dual cta's
		 * /
		 */
		if (window.innerWidth <= 768) {
			if (
				document.getElementsByClassName('sagard-blue-dual-cta--single').length
			) {
				let dualsingles = document.getElementsByClassName(
					'sagard-blue-dual-cta--single'
				)
				Array.from(dualsingles).map((dualsingle) => {
					dualsingle.classList.add('showBackground')
				})
				let i

				// let observerCallback = (entries, observer) => {
				// 	entries.forEach((entry) => {
				// 		if (entry.isIntersecting) {
				// 			if (entry.target.style.backgroundImage) {
				// 				entry.target.classList.add('showBackground')
				// 			}
				// 		} else {
				// 			entry.target.classList.remove('showBackground')
				// 		}
				// 	})
				// }

				// for (i = 0; i < dualsingles.length; i++) {
				// 	let options = {
				// 		root: null,
				// 		rootMargin: '0px',
				// 		threshold: 1.0,
				// 	}

				// 	let observer = new IntersectionObserver(observerCallback, options)
				// 	observer.observe(
				// 		document.getElementsByClassName('sagard-blue-dual-cta--single')[i]
				// 	)
				// }
			}
		}

		gsap.registerPlugin(ScrollTrigger)
		gsap.registerPlugin(CSSPlugin)

		// lazy loads elements with default selector as '.lozad'
		// const observer = lozad();
		// observer.observe();
		const imgObserver = lozad('img')
		imgObserver.observe()

		//		if ($('body').hasClass('portfolio')) {
		//			portfolio()
		//		}

		// default state of mobile menu (closed)
		$('#mobile-menu').css('display', 'none')

		// close mobile nav when link is clicked to prevent mobile menu showing when using
		// browser back button
		let menuItems = document.querySelectorAll('.menu-item')
		let mi
		for (mi = 0; mi < menuItems.length; mi++) {
			menuItems[mi].addEventListener('click', function () {
				if (this.querySelector('a').getAttribute('href') != '#') {
					document.getElementById('mobile-menu').style.display = 'none'
				}
			})
		}

		$('.overview').css('cursor', 'pointer')
		$('.overview').on('click', function () {
			document.location.href = this.querySelector('a').getAttribute('href')
		})

		//const mobileMenu = new sidePanel({
		//	target: $body[0],
		//	props: {
		//		target: $body[0],
		//		content: document.getElementById('mobile-menu'),
		//		fixed: true,
		//		width: 320,
		//	},
		//})
		$('#toggle_nav').on('click', function (e) {
			e.preventDefault()
			$('#mobile-menu').toggle()

			let hnt = document.querySelector('.top-nav-wrap')
			let mm = document.getElementById('mobile-menu')
			let hmd = document.querySelectorAll('#toggle_nav em div')

			if (mm.style.display == 'block') {
				// prevent document scrolling
				$('html').css('overflow', 'hidden')

				if (hnt.style.display != 'none') {
					hnt.style.display = 'none'
				}

				for (i = 0; i < hmd.length; i++) {
					if (i == 0) {
						hmd[i].style.transform = 'translateX(-50%) rotate(45deg)'
						hmd[i].style.top = '10px'
					}
					if (i == 1) {
						hmd[i].style.transform = 'translateX(-50%) rotate(-45deg)'
					}
				}
			} else {
				// enable overflow scrolling
				$('html').css('overflow', 'initial')

				for (i = 0; i < hmd.length; i++) {
					//if (i == 0) {
					//	hmd[i].style.left = '11px'
					//}
					if (i == 0) {
						hmd[i].style.transform = ''
						hmd[i].style.top = '0'
					}
					if (i == 1) {
						hmd[i].style.transform = ''
					}
				}
			}
		})

		$(document).on(
			'click',
			'.menu-section .menu-item-has-children > a',
			function (e) {
				e.preventDefault()
				let $el = $(this)
				$el.parent().toggleClass('show-subnav')
			}
		)

		//	document.addEventListener('DOMContentLoaded', function() {
		//		document.querySelectorAll('.stat-heading').forEach((h) => {
		//			let text = h.innerText
		//		// let span = document.createElement('span')
		//		// span.innerText = text.replace(/[^0-9\.]+/g,"").toString()
		//			let innerText = `<span data-count="${text
		//				.replace(/[^0-9\.]+/g, '')
		//				.toString()}">0</span>`
		//			h.innerHTML = text.replace(/[0-9\.]+/g, innerText)
		//		})
		//	});

		animate()
		loadmore()

		$(document).on('click', '.back-to-top', function (e) {
			e.preventDefault()
			window.scrollTo(0, 0)
		})

		//todo: teammanager
		//todo: prevent team flash
		$('.dropdown-button').on('click', function () {
			$(this).siblings('.team-filters__dropdown-list').toggleClass('active')
			$(this)
				.siblings('.team-filters__dropdown .nav-indicator')
				.toggleClass('show')
		})

		// call on load if filters exists in URL
		const searchParams = new URLSearchParams(
			window.location.search.replace('?', '')
		)
		handleTeamSearch()
		let filters = searchParams.get('filters')
			? decodeURIComponent(searchParams.get('filters'))
			: null
		if (filters) {
			//&& typeof filters !== "null") {
			//there will be at most two
			filters = filters.split(',')
			// handleTeamFilter(filters[0])
			if (
				$('#team-departments-filter').find(`li[data-value=${filters[0]}]`)
					.length
			) {
				// .parent()
				$('#team-departments-filter button')
					.children('span')
					.text($(`li[data-value=${filters[0]}]`).text())
					.parent()
					.attr('data-value', filters[0])
			} else if (
				$('#team-geo-filter').find(`li[data-value=${filters[0]}]`).length
			) {
				$('#team-geo-filter > button')
					// .parent()
					.children('span')
					.text($(`li[data-value=${filters[0]}]`).text())
					.parent()
					.attr('data-value', filters[0])
			}
			if (filters.length > 1) {
				if ($('#team-geo-filter').find(`li[data-value=${filters[1]}]`).length) {
					$('#team-geo-filter > button')
						// .parent()
						.children('span')
						.text($(`li[data-value=${filters[1]}]`).text())
						.parent()
						.attr('data-value', filters[1])
				}
			}
			filterSelection(
				filters,
				document.querySelector('.team__search__input').value.toLowerCase()
			)
		}
		// call on click

		$('.team-filters__dropdown').on('click', function () {
			//address two being open at the same time
			$(this)
				.siblings()
				.find('.team-filters__dropdown-list')
				.removeClass('active')
			$(this).siblings().find('.nav-indicator').removeClass('show')
		})

		$('.team-filters__dropdown-single').on('click', function () {
			const itemValue = $(this).data('value')
			let filteredValues = []

			//record/update value in data
			$(this)
				.parent()
				.siblings('.dropdown-button')
				.children('span')
				.text($(this).text())
				.parent()
				.attr('data-value', itemValue)

			//close menu
			$('.team-filters__dropdown-list').removeClass('active')
			$('.team-filters__dropdown .nav-indicator').removeClass('show')

			//grab active value of each dropdown
			$('.dropdown-button').each(function (index) {
				filteredValues[index] = $(this).attr('data-value')
			})

			//filter with updated active values
			filterSelection(
				filteredValues,
				document.querySelector('.team__search__input').value.toLowerCase()
			)

			const url = new URL(window.location.href)
			url.searchParams.set(
				'filters',
				encodeURIComponent(filteredValues.join(','))
			)
			history.replaceState({}, null, url)

			// // update URL silently
			// if (window.location.search.includes('filters')) {
			// 	history.replaceState(
			// 		{},
			// 		null,
			// 		window.location.pathname +
			// 			window.location.search.replace(
			// 				/(filters=[a-zA-Z\,\-]*(?=&*))/,
			// 				`filters=${filteredValues.join(',')}`
			// 			)
			// 	)
			// } else if (window.location.search) {
			// 	history.replaceState(
			// 		{},
			// 		null,
			// 		window.location.pathname +
			// 			window.location.search +
			// 			'&filters=' +
			// 			filteredValues.join(',')
			// 	)
			// } else {
			// 	history.replaceState(
			// 		{},
			// 		null,
			// 		window.location.pathname + '?filters=' + filteredValues.join(',')
			// 	)
			// }
		})

		$('.board-of-directors-wrap ul.tabs-list li').click(function () {
			const tab_id = $(this).attr('data-tab')

			$('.board-of-directors-wrap__inner-details').addClass('active')
			$('.board-of-directors-wrap ul.tabs-list li').removeClass('active')
			$('.board-of-directors-wrap__inner-details .tab-content').removeClass(
				'active'
			)

			$(this).addClass('active')
			$('#' + tab_id).addClass('active')
			$('html').addClass('active')
		})

		$('.board-of-directors-wrap__inner-details .back-link').click(function (e) {
			e.preventDefault()
			$('.board-of-directors-wrap__inner-details').removeClass('active')
			$('html').removeClass('active')
		})

		//todo: teammanager (end)

		if ($body.hasClass('single-team')) {
			$('.single-team-member__top .back-link a').click((e) => {
				e.preventDefault()
				if (document.referrer.includes(window.location.hostname)) {
					history.back() //does not work for a local server, as history stacks
				} else {
					window.location.href = e.target.href
				}
			})

			//	$(window).on('popstate', function (e) {
			//		e.preventDefault()
			//		history.back()
			//	})
		}

		if ($body.hasClass('team')) {
			//close menu when clicked off
			document.addEventListener('click', closeMenus)

			function closeMenus(e) {
				// console.log(e.target);
				if (
					!e.target.classList.contains('team-filters__dropdown-single') &&
					!e.target.classList.contains('multiSel')
				) {
					let menus = document.getElementsByClassName('dropdown-button')
					//console.log(menus);
					let iter

					for (iter = 0; iter < menus.length; iter++) {
						if (menus[iter].nextElementSibling.classList.contains('show')) {
							menus[iter].nextElementSibling.classList.remove('show')
							//console.log(menus[iter].querySelector('.multiSelect ul'));
							menus[
								iter
							].nextElementSibling.nextElementSibling.classList.remove('active')
							//menus[iter].querySelector('.nav-indicator').classList.remove('show');
						}
					}
				}
			}
		}

		let $careersBtn = $('.btn-careers > *')
		if ($careersBtn.length) {
			$careersBtn.attr('data-lity', true)
			$careersBtn.attr('href', '#careers')
			$careersBtn.click((e) => {
				e.preventDefault()
				animateShow()
			})

			new CareersModal({
				target: document.body,
				props: {
					// eslint-disable-next-line no-undef
					content: careersPUDetails,
				}, //footer.php
			})
		}

		let $termsBtn = $('.btn-terms > *')
		if ($termsBtn.length) {
			$termsBtn.attr('data-lity', true)
			$termsBtn.attr('href', '#terms')
			$termsBtn.click((e) => {
				e.preventDefault()
				animateShow()
			})

			new TermsModal({
				target: document.body,
				props: {
					// eslint-disable-next-line no-undef
					content: termsPUDetails,
				}, //footer.php
			})
		}
		let $privacyBtn = $('.btn-privacy > *')
		if ($privacyBtn.length) {
			$privacyBtn.attr('data-lity', true)
			$privacyBtn.attr('href', '#privacy')
			$privacyBtn.click((e) => {
				e.preventDefault()
				animateShow()
			})

			new PrivacyModal({
				target: document.body,
				props: {
					// eslint-disable-next-line no-undef
					content: privacyPUDetails,
				}, //footer.php
			})
		}

		let $loginBtn = $('.btn-login > *')
		if ($loginBtn.length) {
			$loginBtn.attr('data-lity', true)
			$loginBtn.attr('href', '#login')
			$loginBtn.click((e) => {
				e.preventDefault()
				animateShow()
			})

			new LoginModal({
				target: document.body,
				props: {
					// eslint-disable-next-line no-undef
					content: loginPUDetails,
				}, //footer.php
			})
		}

		$('.sagard-stats').each((_idx, el) => {
			if ($(el).find('.sagard-stat').length % 2) {
				el.classList.add('odd-children')
			} else {
				el.classList.add('even-children')
			}
		})

		if ($('.strategy-slider').length) {
			strategySlider()
		}
		if ($('.case-studies-testimonials-rotator').length) {
			caseStudiesTestimonialsRotator()
		}
		if ($('.case-studies-testimonials-carousel').length) {
			caseStudiesTestimonialsCarousel()
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		let backToTop = document.querySelector('.back-to-top')
		window.addEventListener('scroll', function () {
			let scrollpos = window.scrollY
			// $(':root').css('--navbar-height', $('.navbar-wrap').height())

			if (scrollpos > 100) {
				// if (scrollpos > 100) {
				document.querySelector('.top-nav-wrap').style.display = 'none'
				document.querySelector('.navbar').classList.add('slim')
				if (backToTop) {
					backToTop.style.display = 'block'
				}
				// }
			} else {
				if (document.getElementById('mobile-menu').style.display != 'block') {
					document.querySelector('.top-nav-wrap').style.display = 'block'
				}
				document.querySelector('.navbar').classList.remove('slim')

				if (backToTop) {
					backToTop.style.display = 'none'
				}
			}

			//var topOfFooter = $('#site-footer').position().top
			//var scrollDistanceFromTopOfDoc = $(document).scrollTop() + 840
			//var scrollDistanceFromTopOfFooter = scrollDistanceFromTopOfDoc - topOfFooter

			//if (scrollDistanceFromTopOfDoc > topOfFooter) {
			//	$('.back-to-top').css('margin-bottom', 0 + scrollDistanceFromTopOfFooter)
			//} else {
			//	$('.back-top-top').css('margin-bottom', 0)
			//}
		})

		showFullCookeYesBannerOnFirstVisit()
	},
}

// function communityInvolvement() {
// 	const images = document.querySelectorAll('.comm-involv--slider img')
// 	if (!images) {
// 		return
// 	}
// 	images.forEach((img) => {
// 		img.addEventListener('click', function (e) {
// 			console.log(e.target.src)
// 			BigPicture({
// 				el: e.target,
// 				imgSrc: e.target.src,
// 				gallery: images,
// 				galleryAttribute: 'src',
// 				loop: true,
// 			})
// 		})
// 	})
// }

function animate() {
	// animateTrendlines()
	animateCTA()
	animateFooter()
}

function animateCTA() {
	if (!$('.call-to-action').length) {
		return
	}
	// setTimeout(() => {
	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.call-to-action',
			start: 'center bottom',
			// toggleAction: 'play none none reverse',
			// markers: true
		},
	})

	let d = 0.35
	let settings = {
		opacity: 1,
		duration: d,
		ease: 'power1.out',
		stagger: 0.1,
	}

	gsap.set('.call-to-action h2, .call-to-action h3', { x: -6, opacity: 0 })
	if ($('.call-to-action p').length) {
		gsap.set('.call-to-action p', { y: 6, opacity: 0 })
	}
	if ($('.call-to-action .btn').length) {
		gsap.set('.call-to-action .btn', { opacity: 0 })
	}
	tl.to(
		'.call-to-action h2, .call-to-action h3',
		Object.assign(settings, { x: 0 })
	)
	if ($('.call-to-action p').length) {
		tl.to('.call-to-action p', Object.assign(settings, { y: 0 }), `-=${d}`)
	}
	if ($('.call-to-action .btn').length) {
		tl.to('.call-to-action .btn', Object.assign(settings, {}), `-=0.2`)
	}
	// }, 1000)
}

function animateFooter() {
	gsap.set(
		'.footer-links .menu-section-list:first-of-type h4, .footer-links .menu-section-list:first-of-type li, .footer-links .menu-section-list:nth-of-type(2) li, .footer-locations > div',
		{
			//opacity: 0,
			autoAlpha: 0,
			y: 4,
		}
	)
	gsap.to(
		'.footer-links .menu-section-list:first-of-type h4, .footer-links .menu-section-list:first-of-type li, .footer-links .menu-section-list:nth-of-type(2) li',
		{
			scrollTrigger: {
				trigger: '#site-footer',
			},
			y: 0,
			// scale: 0.96,
			autoAlpha: 1,
			duration: 1,
			ease: 'power1.out',
			stagger: 0.02,
		}
	)
	gsap.to('.footer-locations > div', {
		scrollTrigger: {
			trigger: '#site-footer',
		},
		y: 0,
		autoAlpha: 1,
		duration: 1,
		ease: 'power1.out',
		stagger: 0.1,
	})
	gsap.from('.footer-bottom-grid', {
		scrollTrigger: { trigger: '.footer-bottom-grid' },
		opacity: 0,
		delay: 0.35,
		duration: 0.35,
		ease: 'power1.out',
		stagger: 0.05,
	})
}

function checkIsDepartmentSection(filters, searchQuery) {
	console.log('updating');
	const [department, geography] = filters
	const $heading = $('.team-list:not([data-department]) .team-list__heading h2')
	let dpt_cta = $('.team-list__cta.team-list__cta__' + department);

	// hide all cta's
	$('.team-list__cta').hide();
	
	// show selected department's cta
	if (dpt_cta && dpt_cta.length) {
		dpt_cta.show();
	}

	if (!$heading.attr('data-original-text')) {
		$heading.attr('data-original-text', $heading.text())
	}

	$('.team-list:not([data-department])').show()
	if (searchQuery) {
		//todo: on load + filters
		// console.log(searchQuery)
		$heading.find('+ h3').remove()
		$('.team-list[data-department]').hide()
		//todo: translation
		$heading.text(
			'Search for: ' + document.querySelector('.team__search__input').value
		) //todo: capitalize
		return
	}

	const capitalizeWords = (str) =>
		str
			.split('-')
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ')

	const showAllTeamLists = () => {
		$heading.find('+ h3').remove()
		$heading.text($heading.attr('data-original-text'))
		$('.team-list').show()
	}

	if (
		department &&
		!department.includes('all') &&
		!department.includes('tous') &&
		!department.includes('team-item')
	) {
		const $selectedDepartment = $(`.team-list__${department}`)
		if ($selectedDepartment.length) {
			$selectedDepartment.siblings().hide()
			$selectedDepartment.show()
		} else {
			$('.team-list[data-department]').hide()
			$('.team-list:not([data-department])').show()
		}

		// console.log('department', department)
		//todo: translation
		// let headingtext = capitalizeWords(department)
		let headingtext = document.querySelector('li[data-value=' + department + ']').innerText
		$heading.text(`${headingtext}`);

		if (
			geography &&
			!geography.includes('all-geographies') &&
			!geography.includes('team-item')
		) {
			$heading.find('+ h3').remove() //if change geography, "replace h3"
			let h3
			if (window.location.href.includes('.com/fr')) {
				h3 = $('<h3>').text(capitalizeWords(geography))
			} else {
				h3 = $('<h3>').text('Team: ' + capitalizeWords(geography))
			}
			h3.insertAfter($heading)
		}
		return
	}

	if (
		//todo: french
		geography &&
		!geography.includes('all-geographies') &&
		!geography.includes('team-item')
	) {
		$heading.find('+ h3').remove() // i.e. if select featured department then back to all
		$('.team-list[data-department]').hide()
		if (window.location.href.includes('.com/fr')) {
			$heading.text(capitalizeWords(geography))
		} else {
			$heading.text('Team: ' + capitalizeWords(geography))
		}
		return
	}

	showAllTeamLists()
}

//todo: teammanager
function filterSelection(filters, searchQuery) {
	checkIsDepartmentSection(filters, searchQuery)

	for (let i = 0; i < filters.length; i++) {
		if (filters[i].includes('all') || filters[i].includes('tous')) {
			filters[i] = 'team-item'
		}
	}


	let hideLinkOnCards = true
	//if any filter is in linkedCards, set 
	if (linkedCards) {
		if (
			filters.some((f) => linkedCards.includes(f)) ||
			//only show if linked card is part of a sub-section
			filters.some((f) => selectedACFDepartmentSlugs.includes(f))
		) {
			hideLinkOnCards = false
		}
	}


	//let filteredArray = [...new Set(filters)]
	let members = document.querySelectorAll('.team-list:not([data-department]) .team-item')
	let count = 0 //for all sections - does not matter as search contains all so..

	//cards used dont show position title so it is only by name
	for (let member of members) {
		if (filters.every((fValue) => member.classList.value.includes(fValue))) {
			if (
				searchQuery.length > 0 &&
				!member
					.querySelector('h3')
					.innerText.toLowerCase()
					.includes(searchQuery.toLowerCase())
			) {
				member.style.display = 'none'
			} else {
				member.style.display = 'flex'
				count++
				
				if(hideLinkOnCards)  {
					member.classList.add('hide-link')
				} else {
					member.classList.remove('hide-link')
				}

				// remove no results text if members are found
				Array.from(document.querySelectorAll('.no-results')).map((el) =>
					el.remove()
				)
			}
		} else {
			member.style.display = 'none'
		}
	}

	// no result, show no results text
	if (!count) {
		$('.team-list__grid').hide()
		Array.from(document.querySelectorAll('.no-results')).map((el) =>
			el.remove()
		) //hide previous no results text
		Array.from(document.getElementsByClassName('team-list')).forEach(
			(el, _idx) => {
				if (
					document.getElementsByTagName('html')[0].getAttribute('lang') ==
					'en-US'
				) {
					el.innerHTML += '<p class="no-results">No results.</p>'
				} else {
					el.innerHTML += '<p class="no-results">Aucun résultat.</p>'
				}
			}
		)
	} else {
		$('.team-list__grid').show()
		Array.from(document.querySelectorAll('.no-results')).map((el) =>
			el.remove()
		)
	}

	// Start observing items
	observeItems()
}

function updateURLFromSearch(query) {
	const url = new URL(window.location.href)
	url.searchParams.set('search', query)
	window.history.replaceState({}, '', url)
}

function handleTeamSearch() {
	const searchInput = document.querySelector('.team__search__input')
	if (!searchInput) {
		//not team page
		return
	}
	const searchClear = document.querySelector('.team__search--clear')
	let searchQuery = '',
		timeout

	const url = new URL(window.location.href)
	const searchParams = new URLSearchParams(
		window.location.search.replace('?', '')
	)
	if (searchParams.get('search')) {
		let pageLoadSearch = decodeURIComponent(searchParams.get('search'))
		searchInput.value = pageLoadSearch
		searchQuery = pageLoadSearch
		$(searchClear).show()
	} else {
		$(searchClear).hide()
	}

	//on load
	let filteredValues = []
	//grab active value of each dropdown
	$('.dropdown-button').each(function (index) {
		filteredValues[index] = $(this).attr('data-value')
	})
	filterSelection(filteredValues, searchQuery)

	searchInput.addEventListener('input', () => {
		searchQuery = searchInput.value.toLowerCase()

		updateURLFromSearch(searchQuery)
		if (searchQuery.length < 1) {
			$(searchClear).hide()
		} else {
			$(searchClear).show()
		}

		clearTimeout(timeout)
		timeout = setTimeout(() => {
			//grab active value of each dropdown
			$('.dropdown-button').each(function (index) {
				filteredValues[index] = $(this).attr('data-value')
			})
			filterSelection(filteredValues, searchQuery)
		}, 400)
	})

	searchClear.addEventListener('click', () => {
		searchInput.value = ''
		updateURLFromSearch('')
		$(searchClear).hide()
		$('.dropdown-button').each(function (index) {
			filteredValues[index] = $(this).attr('data-value')
		})
		filterSelection(filteredValues, '')
	})
}

function loadmore() {
	const x = 6
	$('.author-latestposts.more-posts .author-latestposts__single')
		.slice(0, x)
		.addClass('show')

	$('#loadmore').on('click', function (e) {
		e.preventDefault()
		$('.author-latestposts.more-posts .author-latestposts__single:hidden')
			.slice(0, x)
			.fadeIn('slow')
		if (
			$('.author-latestposts.more-posts .author-latestposts__single:hidden')
				.length === 0
		) {
			$('#loadmore').remove()
		}
	})
}

function animateShow() {
	const tl = gsap.timeline({})
	let textWrapper = document.querySelector('.modal h2')
	let spanCheck = textWrapper.querySelectorAll('.word')
	if (!spanCheck.length) {
		textWrapper.innerHTML = textWrapper.textContent.replace(
			/\S+/g,
			"<span class='word'>$&</span> "
		)
	}

	gsap.set('.modal h2 .word', { opacity: 0, y: 24, x: 0, rotateZ: 0 })
	gsap.set('.modal h2 ~ *', { opacity: 0, y: 24 })
	tl.to('.modal h2 .word', {
		delay: 0.2,
		duration: 0.5,
		ease: 'elastic.out(1,0.5)',
		opacity: 1,
		rotateZ: 0,
		stagger: 0.075,
		x: 0,
		y: 0,
	}).to(
		'.modal h2 ~ *',
		{
			duration: 0.3,
			ease: 'power1.out',
			opacity: 1,
			y: 0,
		},
		'-=0.5'
	)

	// setTimeout(() => {
	//    console.log($('.lity-wrap'))
	//    $('.lity-wrap').on('click', (e) => {
	//       e.stopPropagation()
	//       console.log('click')
	//    })
	// }, 150)
}

function handleCareerForms() {
	document.addEventListener('change', function (e) {
		if (e.target && e.target.name.startsWith('contact-resume')) {
			const fileNameField = document.querySelector(
				'[name="contact-resume-name"]'
			)
			if (fileNameField) {
				fileNameField.value = e.target.files[0] ? e.target.files[0].name : ''
			}
		}
	})
	document.addEventListener('change', function (e) {
		if (e.target && e.target.name.startsWith('contact-coverletter')) {
			const fileNameField = document.querySelector(
				'[name="contact-coverletter-name"]'
			)
			if (fileNameField) {
				fileNameField.value = e.target.files[0] ? e.target.files[0].name : ''
			}
		}
	})
}


// function showFullCookeYesBannerOnFirstVisit() {
// 	const $customizeBtn = $('.cky-consent-container:not(.cky-hide) .cky-btn-customize') 
// 	if( $customizeBtn.length) {
// 		$customizeBtn[0].click()
// 	} else {
// 		console.log('CookieYes: revisited')
// 	}
// }

function showFullCookeYesBannerOnFirstVisit() {
	const checkInterval = 100; // Interval between checks (in milliseconds)
	const maxWaitTime = 5000; // Maximum wait time (in milliseconds)
	let elapsedTime = 0;

	function checkElement() {
		 const $customizeBtn = $('.cky-consent-container:not(.cky-hide) .cky-btn-customize');
		 
		 if ($customizeBtn.length) {
			  $customizeBtn[0].click();
		 } else if (elapsedTime >= maxWaitTime) {
			  console.log('CookieYes: revisited');
		 } else {
			  elapsedTime += checkInterval;
			  setTimeout(checkElement, checkInterval);
		 }
	}

	// Start checking for the element
	setTimeout(checkElement, checkInterval);
}
